import BasicSlider from './basic-slider';

export default BasicSlider;
